import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';
import { Clock, ArrowLeft, Tablet } from 'lucide-react';

const AdminLogin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(username, password);
      navigate(u.role === 'superadmin' ? '/superadmin' : '/admin');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Error al iniciar sesión');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-zinc-100 flex items-center justify-center p-4">
      <Card className="w-full max-w-md border-zinc-200 shadow-lg">
        <CardHeader className="text-center space-y-3">
          <div className="flex justify-center">
            <div className="bg-zinc-900 p-3 rounded-2xl"><Clock className="h-7 w-7 text-white" /></div>
          </div>
          <CardTitle className="font-heading text-2xl font-bold text-zinc-900">Panel de Administración</CardTitle>
          <p className="text-zinc-500 text-sm">Acceso para responsables de personal</p>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="username">Usuario</Label>
              <Input id="username" data-testid="admin-username-input" value={username}
                onChange={(e) => setUsername(e.target.value)} required autoComplete="username" />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password">Contraseña</Label>
              <Input id="password" type="password" data-testid="admin-password-input" value={password}
                onChange={(e) => setPassword(e.target.value)} required autoComplete="current-password" />
            </div>
            <Button type="submit" className="w-full bg-zinc-900 hover:bg-zinc-800" disabled={loading} data-testid="admin-login-btn">
              {loading ? 'Accediendo...' : 'Acceder'}
            </Button>
          </form>
          <Link to="/registro" className="block text-center bg-zinc-900/5 hover:bg-zinc-900/10 rounded-lg py-2.5 text-sm font-medium text-zinc-800 mt-5" data-testid="registro-link">
            ¿No tienes cuenta? <span className="text-zinc-900 font-semibold">Prueba gratis</span>
          </Link>
          <Link to="/kiosko" className="flex items-center justify-center gap-2 text-zinc-500 hover:text-zinc-900 text-sm mt-4" data-testid="kiosk-link">
            <Tablet className="h-4 w-4" /> Activar kiosko de fichaje (tablet)
          </Link>
          <Link to="/" className="flex items-center justify-center gap-2 text-zinc-500 hover:text-zinc-900 text-sm mt-3">
            <ArrowLeft className="h-4 w-4" /> Volver a la web
          </Link>
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminLogin;
